<template>
  <div>
    <v-col v-if="selectableProducts.length || selectedProducts.length" sm="sm-10">
      <v-autocomplete
        :disabled="(disabled || inspectMode) && !editMode"
        label="Products"
        prepend-icon="mdi-package-variant"
        :items="selectableProducts"
        item-text="name"
        item-value="id"
        max-height="auto"
        search-input.sync="ean"
        multiple
        :filter="searchProduct"
      >
        <template v-slot:item="data">
          <div style="width: 100%">
            <v-list-item
              @click.native.stop.prevent="addProduct(data)"
              class="d-flex justify-space-between"
            >
              <div>
                <span
                  style="display: inline-block; min-width: 18ch"
                  :class="data.item.isFeRequired || isExceptionalItem(data.item) ? 'red--text' : ''"
                  >{{ data.item.ean }}</span
                >
                <v-chip class="ma-2" color="blue" text-color="white">
                  <v-avatar left class="blue darken-4">{{
                    data.item.count
                  }}</v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </div>
              <span>
                <v-btn
                  v-if="campaignCfg && !campaignCfg.onlyOneProduct"
                  icon
                  @click.stop.prevent="addProduct(data)"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn
                  v-if="campaignCfg && !campaignCfg.onlyOneProduct"
                  icon
                  @click.stop.prevent="removeProduct(data)"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </span>
            </v-list-item>
          </div>
        </template>
      </v-autocomplete>
      <v-data-table
        dense
        :items="selected"
        :disable-pagination="true"
        :hide-default-footer="true"
        :headers="headers"
        no-data-text="No Products Selected"
        :item-key="new Date().getMilliseconds().toString()"
        class="elevation-1"
        disabled
      >
        <template v-slot:[`item.ean`]="{ item }">
          <div :class="item.isFeRequired || isExceptionalItem(item) ? 'red--text' : ''">
            {{ item.ean }}
          </div>
        </template>
        <template v-slot:[`item.price`]="{ item }" :disabled="true">
          <div v-if="!campaignCfg.priceEditable">{{ item.price }}</div>
          <div v-else>
            <v-text-field
              required
              @input="changePrice($event, item)"
              :rules="[rules.price]"
              v-model="item.price"
              :disabled="userRoles === 'AGENT' && !hasGoodWill"
            ></v-text-field>
          </div>
        </template>
        <template
          v-if="campaignCfg && !campaignCfg.onlyOneProduct"
          v-slot:[`item.action`]="{ item }"
        >
          <v-icon small class="mr-2" @click="addProduct(item, true)"
            >mdi-plus</v-icon
          >
          <v-icon small @click="removeProduct(item, true)">mdi-minus</v-icon>
        </template>
        <template v-else v-slot:[`item.action`]="{ item }">
          <v-icon
            small
            @click="removeProduct(item)"
            :disabled="userRoles === 'AGENT' && !hasGoodWill"
          >
            mdi-close
          </v-icon>
        </template>
        <template #[`item.rppData`]="{ item }">
          <div>
            <v-autocomplete
              :items="rppItems"
              v-model="item.rppData"
              @change="updateRpp($event, item)"
              dense
              :disabled="disabled"
            >
              <template #selection="{ item }">
                {{ item.item }}
              </template>
              <template #item="{ item }">
                <div style="width: 100%">
                  <v-list-item
                    class="d-flex justify-space-between"
                  >
                    <div>
                      <span>{{ item.item }}</span>
                      <v-chip color="blue" text-color="black">
                        <span class="black--text">{{ item.price }}</span>
                      </v-chip>
                    </div>
                  </v-list-item>
                </div>
              </template>
            </v-autocomplete>
          </div>
        </template>
      </v-data-table>
      <v-row>
        <v-col sm="6" md="6">
          <v-checkbox
            v-if="hasVatMetro"
            v-model="vatMetro.value"
            :label="'Vat Metro (%' + vatMetroKey + ' ' + vatMetroCountry + ')'"
            @change="applyVatMetro"
          ></v-checkbox>
          <v-checkbox
            v-if="hasRossmannDiscount"
            v-model="rossmannDiscount.value"
            label="10% Rossmann Discount"
            @change="applyRossmannDiscount"
          ></v-checkbox>
        </v-col>
        <v-col>
          <v-text-field
            v-if="campaignCfg && !campaignCfg.onlyOneProduct"
            sm="2"
            md="2"
            class="col-xs-12"
            value="Total"
            disabled
          />
          <v-text-field
            v-else
            sm="2"
            md="2"
            class="col-xs-12"
            value="Cashback"
            disabled
          />
        </v-col>
        <v-col>
          <v-text-field sm="2" md="2" disabled :value="total" />
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
<script>
import { mapFields } from "../store/helpers";
import { mapGetters } from "vuex";

export default {
  props: {
    disabled: {
      type: Boolean
    },
    showDialog: {
      type: Boolean
    },
    hasGoodWill: {
      type: Boolean
    },
    editMode: {
      type: Boolean
    },
    inspectMode: {
      type: Boolean
    },
    retailer: {
      type: Number
    }
  },
  data: () => ({
    dashboarderSelected: [],
    total: 0,
    vatMetroValue: 0,
    vatMetroCountry: "",
    vatMetroKey: 0,
    vatMetro: { value: false, status: 0 },
    rossmannDiscount: { value: false, status: 0 },
    selected: [],
    selectableProducts: [],
    lastTotal: 0,
    lastCountry: "",
    headers: [
      {
        text: "EAN",
        align: "left",
        sortable: false,
        value: "ean"
      },
      {
        text: "Product",
        align: "left",
        sortable: false,
        value: "name"
      },
      {
        text: "RPP Data",
        align: "left",
        sortable: false,
        value: "rppData"
      },
      {
        text: "Price",
        align: "left",
        sortable: false,
        value: "price"
      },
      {
        text: "Count",
        align: "left",
        sortable: false,
        value: "count"
      },
      { text: "Actions", value: "action", sortable: false }
    ],
    rules: {
      price: value => Number.parseFloat(value) > 0 || 'Price should be greater than 0'
    },
    rppItems: []
  }),
  computed: {
    ...mapGetters(["userToken", "isAdmin", "selectedDashboard", "userRoles", "exceptionalItems"]),
    ...mapFields([
      "products",
      "processedProducts",
      "campaign_fk",
      "selectedProducts",
      "paymentAmount",
      "selectedCheckbox",
      "rppData"
    ]),
    campaignCfg: {
      get() {
        if (this.selectedDashboard.campaigns) {
          return this.selectedDashboard.campaigns[this.campaign_fk];
        }
        return false;
      }
    },
    hasVatMetro: {
      get() {
        if (
          this.selectedDashboard &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk].hasVatMetro
        ) {
          this.vatMetro.value = this.selectedCheckbox.vatMetro.value;
          this.vatMetro.status = this.selectedCheckbox.vatMetro.status;
          const country =
            this.$store.state.currentCountry !== ""
              ? this.$store.state.currentCountry
              : this.$store.state.currentReceipt.country !== ""
              ? this.$store.state.currentReceipt.country
              : "";
          if (country !== "") {
            const vatMetroState = this.$store.state.vatMetro;
            if (this.lastCountry !== "" && this.lastCountry !== country) {
              this.vatMetro.value = false;
              this.applyVatMetro();
            }
            if (vatMetroState[country]) {
              this.lastCountry = country;
              this.vatMetroCountry = country;
              this.vatMetroValue = vatMetroState[country].value;
              this.vatMetroKey = vatMetroState[country].key;
              return true;
            } else return false;
          } else return false;
        } else return false;
      }
    },
    hasRossmannDiscount: {
      get() {
        if (
          this.selectedDashboard &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk].rossmannDiscount
        ) {
          if (!this.selectedCheckbox.rossmannDiscount) {
            this.selectedCheckbox.rossmannDiscount = {
              value: false,
              status: 0
            };
          }
          this.rossmannDiscount.value = this.selectedCheckbox.rossmannDiscount.value;
          this.rossmannDiscount.status = this.selectedCheckbox.rossmannDiscount.status;
          return true;
        } else return false;
      }
    },
    isExceptionalItem () {
      return (item) => {
        const items = this.exceptionalItems[this.campaign_fk]
        if (items && items.includes(item.ean)) return true
        else return false
      }
    }
  },
  mounted() {
    this.selectableProducts = this.products.filter(i=> {
      if (!i.retailerId) {
        return true
      } else if (i.retailerId && i.retailerId === this.retailer) {
        return true
      } else return false
    })

    this.selectedProducts.forEach(selected => {
      const p = {
        count: selected.count ? selected.count : 0,
        name: selected.title,
        ean: selected.ean.toString(),
        price: selected.price,
        campaignId: this.campaign_fk
      };

      this.addProduct({ item: p });
    });

    if (this.selectedDashboard.showRppData) {
      try {
        this.rppItems = this.rppData ? JSON.parse(this.rppData) : []
        this.rppItems.push({ item: "N/A", price: 0 })
      } catch (e) {
        this.rppItems = [{ item: "N/A", price: 0 }]
      }
    } else {
      const index = this.headers.findIndex(h => h.value === 'rppData');
      if (index !== -1) this.headers.splice(index, 1);
    }
  },
  methods: {
    applyVatMetro() {
      if (this.vatMetro.value && this.total !== 0) {
        this.selectedCheckbox.vatMetro.value = true;
        if (!this.vatMetro.status) {
          this.selectedCheckbox.vatMetro.status = 1;
          this.vatMetro.status = 1;
          this.lastTotal = this.total;
          this.total = (this.total * this.vatMetroValue).toFixed(2);
          this.processedProducts.forEach(product => {
            product.lastTotal = product.total;
            product.total = (product.total * this.vatMetroValue).toFixed(2);
            this.selected.find(e => {
              if (e.ean === product.groupingId) {
                e.price = (product.total / product.items).toFixed(2);
              }
            });
          });
          console.info(this.processedProducts);
        }
      } else if (!this.vatMetro.value) {
        this.selectedCheckbox.vatMetro.value = false;
        if (this.vatMetro.status) {
          this.selectedCheckbox.vatMetro.status = 0;
          this.vatMetro.status = 0;
          this.total = (this.total * 100) / (100 + this.vatMetroKey).toFixed(2);
          this.processedProducts.forEach(product => {
            product.total =
              (product.total * 100) / (100 + this.vatMetroKey).toFixed(2);
            this.selected.find(e => {
              if (e.ean === product.groupingId) {
                this.changePrice(product.total / product.items, e);
                e.price = (product.total / product.items).toFixed(2);
              }
            });
          });
        }
        console.info(this.processedProducts);
      }
    },
    applyRossmannDiscount() {
      // console.log(
      //   "ROSSMANN::::",
      //   this.rossmannDiscount,
      //   this.selectedCheckbox.rossmannDiscount
      // );
      if (this.rossmannDiscount.value && this.total !== 0) {
        this.selectedCheckbox.rossmannDiscount.value = true;
        // console.log(this.rossmannDiscount);
        if (!this.rossmannDiscount.status) {
          this.selectedCheckbox.rossmannDiscount.status = 1;
          this.rossmannDiscount.status = 1;
          this.lastTotal = this.total;
          this.total = (this.total * 0.9).toFixed(2);
          this.processedProducts.forEach(product => {
            product.lastTotal = product.total;
            product.total = (product.total * 0.9).toFixed(2);
            this.selected.find(e => {
              if (e.ean === product.groupingId) {
                e.price = (product.total / product.items).toFixed(2);
              }
            });
          });
          console.info(this.processedProducts);
        }
      } else if (!this.rossmannDiscount.value) {
        this.selectedCheckbox.rossmannDiscount.value = false;
        if (this.rossmannDiscount.status) {
          this.selectedCheckbox.rossmannDiscount.status = 0;
          this.rossmannDiscount.status = 0;
          this.total = ((this.total * 10) / 9).toFixed(2);

          this.processedProducts.forEach(product => {
            product.lastTotal = product.total;
            product.total = ((product.total * 10) / 9).toFixed(2);
            this.selected.find(e => {
              if (e.ean === product.groupingId) {
                e.price = (product.total / product.items).toFixed(2);
              }
            });
          });
        }
        console.info(this.processedProducts);
      }
    },
    changePrice(e, item) {
      if (
        this.selectedDashboard &&
        this.selectedDashboard.campaigns &&
        this.selectedDashboard.campaigns[this.campaign_fk].hasVatMetro
      ) {
        this.vatMetro.value = false;
        this.applyVatMetro();
      }
      if (this.rossmannDiscount.value) {
        this.rossmannDiscount.value = false;
        this.applyRossmannDiscount();
      }

      let idx = this.products.findIndex(e => e.ean == item.ean);
      this.products[idx].price = e;
      item.price = e;
      this.makePayload(item);
    },
    clean() {
      this.selected = [];
      this.dashboarderSelected = [];
      this.total = 0;
    },
    calculateTotal(products) {
      let _total = 0;

      products.forEach(product => {
        _total += product.count * product.price;
      });
      return _total.toFixed(2);
    },
    makePayload(data) {
      const payload = [];
      const temp = [];

      this.dashboarderSelected.forEach(ean => {
        let product = this.products.find(e => e.ean === ean);
        let selectedInTable = this.selected.find(e => e.ean === ean);

        if (product.count <= 0) return;

        payload.push({
          groupingId: product.ean,
          items: product.count,
          total: product.count * product.price,
          rppData: selectedInTable.rppData
        });
        temp.push(product);
      });
      this.total = this.calculateTotal(temp);
      this.processedProducts = payload;
    },
    addProduct(data, action = false) {
      if (this.campaignCfg && this.campaignCfg.onlyOneProduct && this.processedProducts.length >= 1) {
        return;
      }
      if (
        action &&
        this.selectedDashboard &&
        this.selectedDashboard.campaigns &&
        this.selectedDashboard.campaigns[this.campaign_fk].hasVatMetro
      ) {
        this.vatMetro.value = false;
        this.applyVatMetro();
      }
      if (action && this.rossmannDiscount.value) {
        this.rossmannDiscount.value = false;
        this.applyRossmannDiscount();
      }

      const item = data.item ? data.item : data;
      let found = this.products.find(e => e.ean == item.ean);
      let foundInTable = this.selected.find(e => {
        if (e.ean === item.ean) {
          e.count += 1;
        }
        return e.ean === item.ean;
      });
      if (!found && this.campaignCfg.removeProductIfNotProductList) {
        return
      }
      if (!found) found = {};
      if (found.count === undefined) {
        found.count = item.count ? item.count : 1;
        found.price = item.price / found.count;
      } else {
        found.count += 1;
        this.makePayload(data);
      }
      if (!foundInTable) {
        this.selected.push({
          count: found.count,
          name: found.name,
          ean: found.ean,
          price: found.price,
          isFeRequired: found.isFeRequired
        });
      }
      if (this.dashboarderSelected.includes(item.ean)) {
        return;
      }
      this.dashboarderSelected.push(item.ean);
      this.total = this.calculateTotal(this.selected);

      this.makePayload(data);
      // if(this.userRoles==='AGENT') return
    },
    removeProduct(data, action = false) {
      const item = data.item ? data.item : data;
      if (
        action &&
        this.selectedDashboard &&
        this.selectedDashboard.campaigns &&
        this.selectedDashboard.campaigns[this.campaign_fk].hasVatMetro
      ) {
        this.vatMetro.value = false;
        this.applyVatMetro();
      }
      if (action && this.rossmannDiscount.value) {
        this.rossmannDiscount.value = false;
        this.applyRossmannDiscount();
      }

      let found = this.products.find(e => e.ean == item.ean);
      let foundInTable = this.selected.find((e, idx) => {
        if (e.ean === item.ean) {
          e.count -= 1;
        }
        if (e.count <= 0) {
          e.count = 0;
          this.selected.splice(idx, 1);
        }

        return e.ean === item.ean;
      });
      if (found.count === undefined) {
        found.count = 0;
      } else if (found.count <= 0) {
        found.count = 0;
      } else {
        found.count -= 1;
        this.makePayload(data);
      }
      if (found.count <= 0) {
        const idx = this.dashboarderSelected.indexOf(found.id);
        if (idx !== -1) {
          this.dashboarderSelected.splice(idx, 1);
          this.makePayload(data);
        }
      }
    },
    kickProduct(data) {
      const item = data.item ? data.item : data;
      let found = this.products.find(e => e.ean == item.ean);
      let foundInTable = this.selected.find((e, idx) => {
        if (e.ean === item.ean) {
          this.selected.splice(idx, 1);
        }
        return e.ean === item.ean;
      });
      if (found.count === undefined) {
        found.count = 0;
      } else {
        found.count = 0;
        const idx = this.dashboarderSelected.indexOf(found.id);
        if (idx !== -1) {
          this.dashboarderSelected.splice(idx, 1);
          this.makePayload(data);
        }
      }
    },
    searchProduct(item, inpt) {
      const inputArray = inpt.split(" ");
      if (item.ean.includes(inpt)) {
        return true;
      } else {
        let counter = 0;
        for (const value of inputArray) {
          if (item.name.toUpperCase().includes(value.toUpperCase())) counter++;
        }
        if (counter === inputArray.length) return true;
        return false;
      }
    },
    updateRpp(event, product) {
      const isFound = this.dashboarderSelected.indexOf(product.ean);
      if (isFound >= 0) {
        this.selected[isFound].rppData = event;
        this.makePayload(product);
      }
    },
  },
  watch: {
    retailer(newVal) {
      this.selectableProducts = this.products.filter(i => {
        if (!i.retailerId) {
          return true
        } else if (i.retailerId && i.retailerId === newVal) {
          return true
        } else return false
      })
      console.log('@@@@@@@@@@@RETAILER',newVal, this.products)
    },
    processedProducts(newVal, oldVal) {
      this.dashboarderSelected = [];
      this.processedProducts.forEach(product => {
        this.dashboarderSelected.push(product.groupingId);
        let found = this.products.find(e => e.ean == product.groupingId);
        let foundInTable = this.selected.find(
          e => e.ean === product.groupingId
        );

        // if (found && !foundInTable) {
        //   console.log("HERREREREREER")
        //   this.selected.push(found);}
        // console.log("PRODUCT>>>", found);
        // this.selected.push({ ean: product.groupingId, count: product.items });
      });
    },
    showDialog(newVal, oldVal) {
      // console.log("WATCHHHing", newVal, oldVal, this.selectedProducts);
      // this.clean();
      // this.selectedProducts.forEach(selected => {
      //   const p = { ...selected, name: selected.title };
      //   this.selected.push(p);
      //   console.log("USER SELECTED", this.selected, p);
      // });
    },
    selectedProducts(newVal) {
      // console.log(
      //   "WATCHHHing 2",
      //   newVal,
      //   this.selectedProducts,
      //   "this.selected",
      //   this.selected
      // );
    },
    total(newVal) {
      // this.paymentAmount = newVal;
    }
  }
};
</script>
